import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    purchaseOrderList: () => {
        return HTTP.get('/purchase_order/purchase_order_index', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    purchaseOrderStatus: (id,data) => {
        return HTTP.post('purchase_order/status_update/'+id, data,{
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    purchaseOrderNewList: () => {
        return HTTP.get('purchase_order/get_mat', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addPurchaseOrderNewList: (data) => {
        return HTTP.post('/purchase_order/create_purchase_order',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editPurchaseOrderNewList: (id,data) => {
        return HTTP.post('/purchase_order/purchase_order_update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    purchaseOrderNewDetail: (id) => {
        return HTTP.get('/purchase_order/purchase_order_edit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    purchaseOrderDetail: (id) => {
        return HTTP.get('/purchase_order/purchase_order_preview/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deletePurchaseOrderNewList: (id) => {
        return HTTP.post('/purchase_order/purchase_order_delete/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}